import {remCalc} from '../_utils'

export const globalStyles = () => ({
    '.editorial--html-block a:not(.chakra-button)': {
        color: 'text.tertiary !important',
        textDecoration: 'underline',
        fontWeight: '400',
        cursor: 'pointer',
        _hover: {
            opacity: '0.8',
        },
    },
    'html.search-surface-open, body.search-surface-open': {
        overflow: 'hidden',
        overscrollBehavior: 'none',
        height: '100%',
    },
    'html.img-gallery-modal-open': {
        overflow: 'hidden',
        scrollbarGutter: 'stable',
    },

    //Accesibilitty Global Styles
    ':focus-visible': {
        outline: 'none !important',
        border: 'none !important',
        boxShadow:
            '0 1px 2px 0 var(--chakra-shadows-neutral-sm), 0 0 0 2px var(--chakra-colors-background-base-default), 0 0 0 4px var(--chakra-colors-border-accent-light) !important',
    },
    ':where(:focus-visible)': {
        borderRadius: 'medium',
    },

    //Feedback Global Styles
    '@media screen and (max-width: 991px)': {
        '#chakra-toast-manager-top-right': {
            left: '16px !important',
            right: '16px !important',
            width: 'calc(100% - 32px) !important',
            alignItems: 'center !important',
        },
        '#chakra-toast-manager-top-right > .chakra-toast': {
            width: '100% !important',
            alignItems: 'center !important',
        },
    },

    'button, a, [role="button"]': {
        WebkitTapHighlightColor: 'transparent',
    },

    // editorial full page side-card
    '.full-editorial .editoria-component-side-card': {
        px: {
            base: remCalc(12),
            lg: remCalc(40),
        },
        margin: '0 auto',
    },
})
